import { render } from "./OnlineBookingInvoice.vue?vue&type=template&id=472801d0&scoped=true"
import script from "./OnlineBookingInvoice.vue?vue&type=script&lang=js"
export * from "./OnlineBookingInvoice.vue?vue&type=script&lang=js"

import "./OnlineBookingInvoice.vue?vue&type=style&index=0&id=472801d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472801d0"]])

export default __exports__